import {
  Checkbox,
  TableCell,
  TableRow,
  Text,
  Tooltip,
  WrapperFlex,
} from '@unimed-fesp/components';
import format from 'date-fns/format';
import React from 'react';

import * as jwtDecode from 'jwt-decode';
import { MdDelete, MdListAlt } from 'react-icons/md';
import { useSelector } from 'react-redux';
import theme from '../../../styles/theme';
import EmptyContent from '../../molecules/EmptyContent';
import { ButtonActions, HoverActions } from './styles';

const TableCadastroWebHookBody = ({
  deletarWebhook,
  toggleWebhook,
  openModalEventos,
}) => {
  const { getWebhookConfiguration } = useSelector(
    (state) => state.webhookIntegration
  );

  const { accessToken } = useSelector((state) => state.auth);

  const { IsAdm } = jwtDecode(accessToken);

  const dados = getWebhookConfiguration.data;

  if (dados && dados.length <= 0)
    return (
      <TableRow>
        <TableCell colSpan={6}>
          <EmptyContent />
        </TableCell>
      </TableRow>
    );

  return (
    <>
      <TableRow key={dados.id}>
        <TableCell width={150}>{dados.contractorCode}</TableCell>
        <TableCell width={120}>
          {dados.createdAt
            ? format(new Date(dados.createdAt), 'dd/MM/yyyy HH:mm', {
                timeZone: 'America/Sao_Paulo',
              })
            : '-'}
        </TableCell>
        <TableCell width={120}>{dados.createdUser}</TableCell>
        {dados.updatedAt && (
          <TableCell width={120}>
            {dados.updatedAt
              ? format(new Date(dados.updatedAt), 'dd/MM/yyyy HH:mm', {
                  timeZone: 'America/Sao_Paulo',
                })
              : '-'}
          </TableCell>
        )}
        {dados.updatedBy && (
          <TableCell width={150}>{dados.updatedUser}</TableCell>
        )}
        {IsAdm.toLowerCase() === 'true' && (
          <TableCell width={90}>
            <HoverActions>
              <Tooltip
                background={theme.greenDefault}
                color={theme.bgWhite}
                position="top"
                text={dados.isActive ? 'Desativar' : 'Ativar'}
              >
                <Checkbox
                  checked={dados.isActive}
                  onChecked={() =>
                    toggleWebhook({
                      entity_id: dados.id,
                      isActive: !dados.isActive,
                    })
                  }
                />
              </Tooltip>
            </HoverActions>
          </TableCell>
        )}
        <TableCell width={150}>
          <WrapperFlex gap={10} alignCenter>
            <HoverActions>
              <Tooltip
                background={theme.greenDefault}
                color={theme.bgWhite}
                position="top"
                text="Lista de Eventos"
              >
                <ButtonActions
                  width={40}
                  padding={5}
                  justifyCenter
                  onClick={openModalEventos}
                  background={theme.greenDefault}
                >
                  <MdListAlt color={theme.white} size={25} />
                </ButtonActions>
              </Tooltip>
            </HoverActions>
            <HoverActions>
              <Tooltip
                background={theme.red}
                color={theme.bgWhite}
                position="top"
                text="Excluir Configuração"
              >
                <ButtonActions
                  width={40}
                  padding={5}
                  justifyCenter
                  onClick={() => deletarWebhook(dados.id)}
                  background={theme.red}
                >
                  <MdDelete color={theme.white} size={25} />
                </ButtonActions>
              </Tooltip>
            </HoverActions>
          </WrapperFlex>
        </TableCell>
      </TableRow>
    </>
  );
};

export default TableCadastroWebHookBody;
